module.exports = __webpack_public_path__ + "img/total-value-staked.b67d94d7.svg";